<template>
  <div id="app" class="jdy-page">
    <router-view />
    <!-- <svg-icon style='display:none'></svg-icon> -->
  </div>
</template>
<script>
  import Vue from 'vue'
  export default {
    name: 'App'
  }
</script>


// WEBPACK FOOTER //
// src/App.vue